module.exports = __webpack_public_path__ + "static/media/cows-bg-2.95e2b98f.jpg";